import { useState } from 'react';
import questionnaireService from '../services/questionnaireService';

const useQuestionnaire = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getResponses = async (projectId) => {
    try {
      setLoading(true);
      setError(null);
      const responses = await questionnaireService.getResponses(projectId);
      return responses;
    } catch (err) {
      setError(err.message || 'Failed to fetch responses');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const saveResponses = async (projectId, responses) => {
    try {
      setLoading(true);
      setError(null);
      const savedResponses = await questionnaireService.saveResponses(projectId, responses);
      return savedResponses;
    } catch (err) {
      setError(err.message || 'Failed to save responses');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const submitQuestionnaire = async (projectId) => {
    try {
      setLoading(true);
      setError(null);
      const result = await questionnaireService.submitQuestionnaire(projectId);
      return result;
    } catch (err) {
      setError(err.message || 'Failed to submit questionnaire');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const generateAPD = async (projectId) => {
    try {
      setLoading(true);
      setError(null);
      const document = await questionnaireService.generateAPD(projectId);
      return document;
    } catch (err) {
      setError(err.message || 'Failed to generate APD');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    getResponses,
    saveResponses,
    submitQuestionnaire,
    generateAPD
  };
};

export default useQuestionnaire;